// extracted by mini-css-extract-plugin
export default {"image_list":"Images_image_list__PZodN","splide":"Images_splide__dP224","image":"Images_image__h13Pt","order_arrow":"Images_order_arrow__QTQ2v","icon":"Images_icon__Q4k5R"};